// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"ZUBRG","loaderContainer":"zehYB"};